import { array } from '@mojotech/json-type-validation'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { HistoryRepository } from '@/domain/repositories/history/historyRepository'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { judgeRecordDecoder } from '@/infrastructure/decoders/judge/judgeRecordDecoder'

export class HistoryRepositoryImpl implements HistoryRepository {
  constructor(private clients: ApiClients) {}

  async getUserJudgeHistory(userId: string, problemId: string, pageIndex: number): Promise<JudgeRecord[]> {
    const size = 20
    const path = `submission_records/users/${userId}/problems/${problemId}?page=${pageIndex}&size=${size}`
    return this.clients.aojClient.fetchAndDecode(array(judgeRecordDecoder), path)
  }
}
